import agent from "./agent";

export function getPromo(search, isActive, skip, limit) {
  const query = {
    search,
    isActive,
  };
  if (isActive === "all") delete query.isActive;
  return agent.get(`promos/getListPanel`, {
    params: { filter: query, skip: skip * limit, limit },
  });
}

export function getPromoDetail(id) {
  return agent.get(`promos/${id}/getDetail`);
}

export function getPromoAll(search) {
  return agent.get(`promos/getListPanel`, {
    params: { filter: { search } },
  });
}

export function editPromo(id, body) {
  return agent.put(`promos/${id}/edit`, { ...body });
}

export function syncPromo() {
  return agent.get("promos/sync");
}
